import {styled} from "@mui/material/styles"
import {Backdrop, Paper} from "@mui/material"

export const DrawerBackdrop = styled(Backdrop)`
    background: ${({theme}) => theme.uxfabric.components.backdrop.default.backgroundColor};
    border-top: 1px solid #eeeeee;
`

export const DrawerPaper = styled(Paper)`
    & {
        box-shadow: none;
        border-radius: unset;
        width: calc(100% - 2.75rem);
        padding: unset;
        position: relative;
        height: 100%;
        overflow: hidden;
        margin-top: 0.0625rem;
    }
`

export const BurgerBodyContainer = styled("div")`
    height: 100%;
    flex: 1 1 auto;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
`
